export const MODEL_ADD_VIDEO = 'MODEL_ADD_VIDEO';
export const MODEL_ADD_VIDEO_SUCCESS = 'MODEL_ADD_VIDEO_SUCCESS';
export const MODEL_ADD_VIDEO_ERROR = 'MODEL_ADD_VIDEO_ERROR';
export const MODEL_ADD_VIDEO_CLEAN_STATE = 'MODEL_ADD_VIDEO_CLEAN_STATE';
